import { Dispatch, SetStateAction, useEffect, RefObject } from "react";

function useOutsideHandler(
  ref: RefObject<HTMLDivElement>,
  closeOption: Dispatch<SetStateAction<any>>
) {
  useEffect(() => {
    /**
     * Alert if clicked on outside of element
     */
    function handleClickOutside(event: any) {
      if (ref.current && !ref.current.contains(event.target)) {
        closeOption(false);
      }
    }

    // Bind the event listener
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Unbind the event listener on clean up
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [ref]);
}

export default useOutsideHandler;
